import "./Portfolio.css";
import Menu from "./Menu"; 
import { useState } from "react";

const Portfolio = () => {
  const [items, setItems] = useState(Menu);
  const filterItem = (categoryItem) => {
    const updatedItems = Menu.filter((currElem) => {
      return currElem.category === categoryItem;
    });

    setItems(updatedItems);
  };

  return (
    <section className="work container section" id="portfolio">
      <h2 className="section__title">
        Projects
      </h2>

      <div className="work__filters">
        <span className="work__item" onClick={() => setItems(Menu)}>
          All
        </span>
        <span className="work__item" onClick={() => filterItem("Mobile App")}>
          Mobile App
        </span>
        <span className="work__item" onClick={() => filterItem("Web App")}>
          Web App
        </span>
        <span className="work__item" onClick={() => filterItem("Website")}>
          Website
        </span>
        <span className="work__item" onClick={() => filterItem("Design")}>
          Design
        </span>
      </div>

      <div className="work__container grid">
        {items.map((element) => {
          const { id, image, title, category, link } = element;
          return (
            <div className="work__card" key={id}>
              <div className="work__thumbnail">
                <img src={image} alt="project N" className="work__img" />
                <div className="work__mask"></div>
              </div>

              <span className="work__category">
                {category}
              </span>

              <h3 className="work__title">
                {title}
              </h3>

              <a href={link} className="work__button" target="_blank" rel="noreferrer">
                <i className="icon-link work__button-icon"></i>
              </a>
            </div>
          );
        })}
      </div>
    </section>
  )
}

export default Portfolio